import React from 'react'
import styled from 'styled-components'
import { mobileVW, desktopVW } from '../../styles'
import theme from '../../styles/theme'
import Image from 'gatsby-image'

const { colors, breakPoints, fontFamily } = theme

const DynamicLabel = (props) => {
  return (
    <DynamicLabelWrapper css={props.style}>
      <LabelElem {...props} />
    </DynamicLabelWrapper>
  )
}

const LabelElem = (props) => {
  const { text, image, type } = props

  switch (type) {
    case 'image':
      return (
        props[type] && (
          <ImageLabel>
            <Image fluid={image.fluid} />
          </ImageLabel>
        )
      )
    case 'text':
      return props[type] && <TextLabel>{text}</TextLabel>
    default:
      return null
  }
}

export const DynamicLabelWrapper = styled.div``

const ImageLabel = styled.div`
  z-index: 5;
  display: flex;
  flex-flow: column;
  width: ${mobileVW(52)};
  height: auto;
  border-radius: 50%;
  overflow: hidden;

  @media only screen and (min-width: ${breakPoints.desktop}) {
    width: ${desktopVW(60, 1440)};
  }
`

const TextLabel = styled.span`
  font-size: ${mobileVW(10)};
  padding: 0.8em 1.25em;
  line-height: 1.5;
  background: ${colors.lightBlue};
  border-radius: 100em;
  height: auto;
  width: auto;
  display: flex;
  color: ${colors.blue};

  @media only screen and (min-width: ${breakPoints.desktop}) {
    font-size: ${desktopVW(11, 1440)};
  }
`

export default DynamicLabel
